<section class="payment-list-wrapper">
  <div class="message error" *ngIf="!isAuthenticated">Please log in first.</div>

  <section *ngIf="isAuthenticated">
    <div class="message info" *ngIf="isLoading">{{ status }}</div>
    <div class="message error" *ngIf="error">{{ error }}</div>
    <div class="message info" *ngIf="!isLoading && !error && yearlySummaryText">{{ yearlySummaryText }}</div>

    <app-entity-list
      *ngIf="!error"
      [loading]="isLoading"
      [list]="paymentList"
      [deletedMode]="deletedMode"
      [showMenuInDeletedMode]="deletedMode"
      [tableHeaderAndValueKeySets]="tableHeaderAndValueKeySets"
      [desktopColumnTemplate]="paymentListColumnTemplate"
      [menuActions]="paymentMenuActions"
      [emptyMessage]="'No payment found.'"
      (cardClick)="onCardClickFromList($event)"
      (editClick)="onEditClickFromList($event)"
      (deleteClick)="onDeleteClickFromList($event)"
      (menuAction)="onMenuAction($event)"
      (loadMore)="onLoadMoreFromList()"
    ></app-entity-list>
  </section>

  <div class="modal-overlay" *ngIf="isDetailsOpen && selectedPayment" (click)="closeDetailsModal()">
    <div class="details-modal" (click)="$event.stopPropagation()">
      <button class="close-icon" type="button" aria-label="Close" (click)="closeDetailsModal()">&times;</button>
      <h3>Payment Details</h3>
      <div class="details-grid">
        <div class="details-item">
          <span class="label">Flat</span>
          <span class="value">{{ selectedPayment.flatRenterMapping?.flat?.flatName || 'N/A' }}</span>
        </div>
        <div class="details-item">
          <span class="label">Renter</span>
          <span class="value">{{ selectedPayment.flatRenterMapping?.renter?.renterName || 'N/A' }}</span>
        </div>
        <div class="details-item">
          <span class="label">Payment Month</span>
          <span class="value">{{ paymentMonthLabel(selectedPayment.paymentMonth, selectedPayment.paymentYear) }}</span>
        </div>
        <div class="details-item">
          <span class="label">Payment Date</span>
          <span class="value">{{ formatDate(selectedPayment.paymentDate) }}</span>
        </div>
        <div class="details-item">
          <span class="label">Payment Method</span>
          <span class="value">{{ paymentMethodLabel(selectedPayment.paymentMethod) }}</span>
        </div>
        <div class="details-item">
          <span class="label">Transaction No</span>
          <span class="value">{{ selectedPayment.txnNo || 'N/A' }}</span>
        </div>
        <div class="details-item">
          <span class="label">Created On</span>
          <span class="value">{{ formatDateTime(selectedPayment.createdOn) }}</span>
        </div>
        <div class="details-item">
          <span class="label">Created By</span>
          <span class="value">{{ actorLabel(selectedPayment.createdByUser, selectedPayment.createdBy) }}</span>
        </div>
        <div class="details-item" *ngIf="hasRecordedUpdate(selectedPayment)">
          <span class="label">Updated On</span>
          <span class="value">{{ formatDateTime(selectedPayment.updatedOn) }}</span>
        </div>
        <div class="details-item" *ngIf="hasRecordedUpdate(selectedPayment) && hasUpdatedActor(selectedPayment)">
          <span class="label">Updated By</span>
          <span class="value">{{ actorLabel(selectedPayment.updatedByUser, selectedPayment.updatedBy) }}</span>
        </div>
        <div class="details-item details-item-full">
          <span class="label">Remarks</span>
          <span class="value">{{ selectedPayment.remarks || 'N/A' }}</span>
        </div>
        <div class="details-item" *ngIf="hasPositiveAmount(selectedPayment.rentAmount)">
          <span class="label">Rent</span>
          <span class="value">{{ selectedPayment.rentAmount }}</span>
        </div>
        <div class="details-item" *ngIf="hasPositiveAmount(selectedPayment.gasBillAmount)">
          <span class="label">Gas</span>
          <span class="value">{{ selectedPayment.gasBillAmount }}</span>
        </div>
        <div class="details-item" *ngIf="hasPositiveAmount(selectedPayment.electricBillAmount)">
          <span class="label">Electric</span>
          <span class="value">{{ selectedPayment.electricBillAmount }}</span>
        </div>
        <div class="details-item" *ngIf="hasPositiveAmount(selectedPayment.waterBillAmount)">
          <span class="label">Water</span>
          <span class="value">{{ selectedPayment.waterBillAmount }}</span>
        </div>
        <div class="details-item" *ngIf="hasPositiveAmount(selectedPayment.serviceChargeAndOtherAmount)">
          <span class="label">Service Charge + Other</span>
          <span class="value">{{ selectedPayment.serviceChargeAndOtherAmount }}</span>
        </div>
        <div class="details-item" *ngIf="hasPositiveAmount(selectedPayment.negativeChargeAmount)">
          <span class="label">{{ selectedPayment.flatRenterMapping?.flat?.negativeChargeName || 'Negative Charge' }}</span>
          <span class="value">{{ selectedPayment.negativeChargeAmount }}</span>
        </div>
        <div class="details-item" *ngIf="hasPositiveAmount(selectedPayment.advanceAdjustedAmount)">
          <span class="label">Adjust From Advance</span>
          <span class="value">{{ selectedPayment.advanceAdjustedAmount }}</span>
        </div>
      </div>
      <div class="details-actions">
        <button type="button" class="panel-item" (click)="closeDetailsModal()">Close</button>
      </div>
    </div>
  </div>

  <div class="modal-overlay" *ngIf="isHistoryOpen && selectedPayment" (click)="closeHistoryModal()">
    <div class="details-modal history-modal" (click)="$event.stopPropagation()">
      <button class="close-icon" type="button" aria-label="Close" (click)="closeHistoryModal()">&times;</button>
      <h3>Payment History</h3>
      <div class="history-subtitle">
        {{ selectedPayment.flatRenterMapping?.flat?.flatName || 'N/A' }} | Txn {{ selectedPayment.txnNo || 'N/A' }}
      </div>

      <div class="history-list" *ngIf="selectedPaymentHistory.length > 0; else emptyHistory">
        <div class="history-header">
          <span>Recorded On</span>
          <span>By</span>
          <span>Month</span>
          <span>Method</span>
          <span>Amount</span>
          <span>Remarks</span>
        </div>
        <div class="history-card" *ngFor="let history of selectedPaymentHistory" (click)="openHistoryDetails(history)">
          <span>{{ formatDateTime(history.createdOn) }}</span>
          <span class="history-actor">{{ historyByLabel(history) }}</span>
          <span>{{ paymentMonthLabel(history.paymentMonth, history.paymentYear) }}</span>
          <span>{{ paymentMethodLabel(history.paymentMethod) }}</span>
          <span>{{ formatAmount(historyAmount(history)) }}</span>
          <span class="history-remarks">{{ history.remarks || 'N/A' }}</span>
        </div>
      </div>

      <ng-template #emptyHistory>
        <div class="message info">No history found.</div>
      </ng-template>

      <div class="details-actions">
        <button type="button" class="panel-item" (click)="closeHistoryModal()">Close</button>
      </div>
    </div>
  </div>

  <div class="modal-overlay" *ngIf="isHistoryDetailsOpen && selectedHistoryItem" (click)="closeHistoryDetailsModal()">
    <div class="details-modal" (click)="$event.stopPropagation()">
      <button class="close-icon" type="button" aria-label="Close" (click)="closeHistoryDetailsModal()">&times;</button>
      <h3>History Details</h3>
      <div class="details-grid">
        <div class="details-item">
          <span class="label">Transaction No</span>
          <span class="value">{{ selectedHistoryItem.txnNo || selectedPayment?.txnNo || 'N/A' }}</span>
        </div>
        <div class="details-item">
          <span class="label">Payment Month</span>
          <span class="value">{{ paymentMonthLabel(selectedHistoryItem.paymentMonth, selectedHistoryItem.paymentYear) }}</span>
        </div>
        <div class="details-item">
          <span class="label">Payment Date</span>
          <span class="value">{{ formatDate(selectedHistoryItem.paymentDate) }}</span>
        </div>
        <div class="details-item">
          <span class="label">Payment Method</span>
          <span class="value">{{ paymentMethodLabel(selectedHistoryItem.paymentMethod) }}</span>
        </div>
        <div class="details-item">
          <span class="label">Recorded On</span>
          <span class="value">{{ formatDateTime(selectedHistoryItem.createdOn) }}</span>
        </div>
        <div class="details-item" *ngIf="hasUpdatedActor(selectedHistoryItem)">
          <span class="label">Updated By</span>
          <span class="value">{{ actorLabel(selectedHistoryItem.updatedByUser, selectedHistoryItem.updatedBy) }}</span>
        </div>
        <div class="details-item">
          <span class="label">Created By</span>
          <span class="value">{{ actorLabel(selectedHistoryItem.createdByUser, selectedHistoryItem.createdBy) }}</span>
        </div>
        <div class="details-item details-item-full">
          <span class="label">Remarks</span>
          <span class="value">{{ selectedHistoryItem.remarks || 'N/A' }}</span>
        </div>
        <div class="details-item" *ngIf="hasPositiveAmount(selectedHistoryItem.rentAmount)">
          <span class="label">Rent</span>
          <span class="value">{{ selectedHistoryItem.rentAmount }}</span>
        </div>
        <div class="details-item" *ngIf="hasPositiveAmount(selectedHistoryItem.gasBillAmount)">
          <span class="label">Gas</span>
          <span class="value">{{ selectedHistoryItem.gasBillAmount }}</span>
        </div>
        <div class="details-item" *ngIf="hasPositiveAmount(selectedHistoryItem.electricBillAmount)">
          <span class="label">Electric</span>
          <span class="value">{{ selectedHistoryItem.electricBillAmount }}</span>
        </div>
        <div class="details-item" *ngIf="hasPositiveAmount(selectedHistoryItem.waterBillAmount)">
          <span class="label">Water</span>
          <span class="value">{{ selectedHistoryItem.waterBillAmount }}</span>
        </div>
        <div class="details-item" *ngIf="hasPositiveAmount(selectedHistoryItem.serviceChargeAndOtherAmount)">
          <span class="label">Service Charge + Other</span>
          <span class="value">{{ selectedHistoryItem.serviceChargeAndOtherAmount }}</span>
        </div>
        <div class="details-item" *ngIf="hasPositiveAmount(selectedHistoryItem.negativeChargeAmount)">
          <span class="label">{{ selectedPayment?.flatRenterMapping?.flat?.negativeChargeName || 'Negative Charge' }}</span>
          <span class="value">{{ selectedHistoryItem.negativeChargeAmount }}</span>
        </div>
        <div class="details-item" *ngIf="hasPositiveAmount(selectedHistoryItem.advanceAdjustedAmount)">
          <span class="label">Adjust From Advance</span>
          <span class="value">{{ selectedHistoryItem.advanceAdjustedAmount }}</span>
        </div>
      </div>
      <div class="details-actions">
        <button type="button" class="panel-item" (click)="closeHistoryDetailsModal()">Close</button>
      </div>
    </div>
  </div>

  <div class="modal-overlay" *ngIf="isSendReceiptOpen && selectedPayment" (click)="closeSendReceiptModal()">
    <div class="details-modal send-receipt-modal" (click)="$event.stopPropagation()">
      <button class="close-icon" type="button" aria-label="Close" (click)="closeSendReceiptModal()">&times;</button>
      <h3>Send Receipt</h3>
      <p class="send-receipt-subtitle">Email sends the receipt PDF. WhatsApp sends the same receipt data as text.</p>

      <div class="send-receipt-form">
        <label class="send-receipt-field">
          <span class="send-receipt-label">Receipt</span>
          <input type="text" [ngModel]="sendReceiptLabel()" readonly />
        </label>

        <label class="send-receipt-field">
          <span class="send-receipt-label">WhatsApp Number</span>
          <input
            type="text"
            [(ngModel)]="sendReceiptWhatsappNumber"
            placeholder="Type renter WhatsApp number"
          />
        </label>

        <label class="send-receipt-field">
          <span class="send-receipt-label">Email</span>
          <input
            type="email"
            [(ngModel)]="sendReceiptEmail"
            placeholder="Type renter email"
          />
        </label>
      </div>

      <div class="message error" *ngIf="sendReceiptError">{{ sendReceiptError }}</div>
      <div class="message info" *ngIf="sendReceiptSuccess">{{ sendReceiptSuccess }}</div>

      <div class="details-actions send-receipt-actions">
        <button type="button" class="panel-item" (click)="closeSendReceiptModal()">Close</button>
        <button
          type="button"
          class="send-receipt-btn whatsapp-btn"
          (click)="sendReceiptByWhatsapp()"
          [disabled]="isPreparingWhatsapp"
        >
          {{ isPreparingWhatsapp ? 'Opening...' : 'Text Via WhatsApp' }}
        </button>
        <button
          type="button"
          class="send-receipt-btn email-btn"
          (click)="sendReceiptByEmail()"
          [disabled]="isSendingReceiptEmail"
        >
          {{ isSendingReceiptEmail ? 'Sending...' : 'PDF Via Email' }}
        </button>
      </div>
    </div>
  </div>

  <app-make-payment
    *ngIf="isEditOpen"
    [mode]="selectedPayment ? 'edit' : 'create'"
    [initialPayment]="selectedPayment"
    [prefillContext]="createPrefillContext"
    [receiptOrganizationName]="receiptOrganizationName"
    [receiptBrandName]="receiptBrandName"
    [receiptBrandLogoUrl]="receiptBrandLogoUrl"
    (close)="closeEditModal()"
    (save)="onEditSave($event)"
  ></app-make-payment>

  <app-confirm-action-modal
    [visible]="!!pendingDeletePayment"
    [title]="'payment.deleteTitle' | t:'Delete Payment'"
    [message]="'payment.deleteMessage' | t:'Delete this payment?'"
    [confirmLabel]="'action.delete' | t:'Delete'"
    [isLoading]="isDeleting"
    [danger]="true"
    (cancel)="closeDeleteModal()"
    (confirm)="confirmDeletePayment()"
  ></app-confirm-action-modal>
</section>

